// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"styles_dashboard__3o86f"};